import { isBrandInNAM } from "@faire/help-center-self-serve/utils/isBrandInNAM";
import brandPortalAccountRoute from "@faire/web-api/routes/brand-portal/account";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { RowWithBullet } from "../common/RowWithBullet";
export var UpdatePayoutsIA = function UpdatePayoutsIA(_ref) {
  var brand = _ref.brand;
  if (isBrandInNAM(brand)) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "gbEM9B",
      defaultMessage: [{
        "type": 0,
        "value": "You can choose when you want to get paid after orders ship. Payouts are initiated based on the payout option selected, but may take 3–5 working days to reflect in your account, depending on your bank’s processing time. Your payment-processing fee is based on your selection."
      }]
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg
    /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */, {
      id: "CYGSaU",
      /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Next day payout"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": 3.5% + £0.30"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg
    /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */, {
      id: "zaIu+A",
      /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "30-day payout"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": 2.4% + £0.30"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg
    /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */, {
      id: "bZnAZH",
      /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "60-day payout"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": 1.9% + £0.30"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "q1sTS9",
      defaultMessage: [{
        "type": 0,
        "value": "To change your payout option, and corresponding payment-processing fee, go to "
      }, {
        "children": [{
          "type": 0,
          "value": "Account settings"
        }],
        "type": 8,
        "value": "AccountSettingLinkFormatting"
      }, {
        "type": 0,
        "value": " and select the "
      }, {
        "children": [{
          "type": 0,
          "value": "Payout"
        }],
        "type": 8,
        "value": "PayoutLinkFormatting"
      }, {
        "type": 0,
        "value": " tab."
      }],
      values: {
        AccountSettingLinkFormatting: function AccountSettingLinkFormatting(chunks) {
          return PayoutsLinkFormatting(chunks, "my-account");
        },
        PayoutLinkFormatting: function PayoutLinkFormatting(chunks) {
          return PayoutsLinkFormatting(chunks, "payment");
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "oGyzWH",
      defaultMessage: [{
        "type": 0,
        "value": "Changes will apply to all future orders placed after the payout setting is updated. Contact us to change your payout option on existing orders."
      }]
    })));
  }
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "iMNCJo",
    defaultMessage: [{
      "type": 0,
      "value": "You can choose when you want to get paid after orders ship. Payouts are initiated based on the payout option selected, but may take 3–5 working days to reflect in your account, depending on your bank’s processing time. Your payment-processing fee is based on your selection."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "3kOCho",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "ACH Next Day"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": 3% payout fee is applied to both the order and shipping costs"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "ljpEqK",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "ACH 30-day"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": no payout fee"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "S45UJf",
    defaultMessage: [{
      "type": 0,
      "value": "To change your payout option, and corresponding payment processing fee, go to "
    }, {
      "children": [{
        "type": 0,
        "value": "Account settings"
      }],
      "type": 8,
      "value": "AccountSettingLinkFormatting"
    }, {
      "type": 0,
      "value": " and select the "
    }, {
      "children": [{
        "type": 0,
        "value": "Payout"
      }],
      "type": 8,
      "value": "PayoutLinkFormatting"
    }, {
      "type": 0,
      "value": " tab."
    }],
    values: {
      AccountSettingLinkFormatting: function AccountSettingLinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "my-account");
      },
      PayoutLinkFormatting: function PayoutLinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "payment");
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "JR23KI",
    defaultMessage: [{
      "type": 0,
      "value": "Changes will apply to all future orders placed after the payout setting is updated. Contact us to change your payout option on existing orders."
    }]
  })));
};
var PayoutsLinkFormatting = function PayoutsLinkFormatting(chunks, tab) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalAccountRoute({
      tab: tab
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};